import { render, staticRenderFns } from "./audiences.vue?vue&type=template&id=5353a376&scoped=true"
import script from "./audiences.vue?vue&type=script&lang=js"
export * from "./audiences.vue?vue&type=script&lang=js"
import style0 from "./audiences.vue?vue&type=style&index=0&id=5353a376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353a376",
  null
  
)

export default component.exports